import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Present: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn(s.svg, 'svg-icon--present')}
    viewBox="0 0 37.4 37.4"
    data-icon={icon}
  >
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path d="M35.7 7.5H31a1.5 1.5 0 0 0 0-.5v-.4c.1-1.5.2-4.3-1.2-5.7a2.8 2.8 0 0 0-2.1-.9c-2.2 0-5 2-6 2.9a17.4 17.4 0 0 0-3 2.8 17.4 17.4 0 0 0-3-2.8C14.8 2 12 0 9.8 0a2.8 2.8 0 0 0-2.1.9C6.2 2.3 6.3 5 6.3 6.6V7a1.5 1.5 0 0 0 0 .4H1.8A1.7 1.7 0 0 0 0 9.2v7.2A1.7 1.7 0 0 0 1.7 18h1.4v18a1.2 1.2 0 0 0 1.2 1.3h28.8a1.2 1.2 0 0 0 1.2-1.2V18h1.4a1.7 1.7 0 0 0 1.7-1.7V9.2a1.7 1.7 0 0 0-1.7-1.7zm-15.2 9.1h-3.6V9h3.6zM22.7 4c2-1.5 3.8-2.4 5-2.4a1.4 1.4 0 0 1 1 .4c1 1 1 3.5 1 4.6v.6c0 .2-8.5.3-9.1.2a2 2 0 0 1-1-.2A11.7 11.7 0 0 1 22.7 4zm-14-2a1.4 1.4 0 0 1 1-.4c1.2 0 3 .9 5 2.4a11.7 11.7 0 0 1 3 3.2 2 2 0 0 1-.8.2c-.7.1-9-.2-9-.3v-.5c-.1-1-.2-3.6.7-4.6zM1.4 16.4V9.2a.3.3 0 0 1 .2-.2h13.7v7.7H1.7a.3.3 0 0 1-.2-.3zm3 19.5V18.1h11v17.8zM17 36V18.1h3.6v17.8zm16 0H22V18.1h10.8zm3-19.5a.3.3 0 0 1-.2.2H22V9h13.7a.3.3 0 0 1 .2.2z" />
      </g>
    </g>
  </svg>
);

export default Present;
